import { render } from "./ServerError.vue?vue&type=template&id=5ef0fd51&scoped=true"
import script from "./ServerError.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerError.vue?vue&type=script&setup=true&lang=js"

import "./ServerError.vue?vue&type=style&index=0&id=5ef0fd51&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef0fd51"],['__file',"src/components/errors/ServerError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ef0fd51"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ef0fd51', __exports__)) {
    api.reload('5ef0fd51', __exports__)
  }
  
  module.hot.accept("./ServerError.vue?vue&type=template&id=5ef0fd51&scoped=true", () => {
    api.rerender('5ef0fd51', render)
  })

}


export default __exports__